module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsMother.6a576c0.jpg";